module.exports = __webpack_public_path__ + "img/aborea.c75382ab.png";